import ManagerForm from './ManagerForm';

export default ManagerForm;
